import {useContext} from "react";
import SupplierGuidEnum from "../../../../models/SupplierGuidEnum";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IPacking_List from "../../../../models/IPacking_List";
import IPackingListViewOptions from "../../../../models/IPackingListViewOptions";
import IOrder from "../../../../models/IOrder";
import SupplierContext from "../../../../contexts/SupplierContext";
import IAddress from "../../../../models/IAddress";
import _ from "lodash";
import IVendorModel from "../../../../models/IVendorModel";
import UiContext from "../../../../contexts/UiContext";
import UIService from "../../../../services/UIService";
import UserContext from "../../../../contexts/UserContext";
import UserService from "../../../../services/UserService";
import moment from "moment-timezone";

type Props = {
    packingList: IPacking_List;
    view: IPackingListViewOptions;
    pageSize: "STANDARD" | "MINIMAL";
    firstOrder: IOrder;
    orders: IOrder[];
    totalOrders: number;
    getCompiledData: () => { orderNumsArr: string[]; poNumsArr: string[]; notes: string; shipping_instructions: string; orderDescription: string; },
    getOrderDate: () => string,
    getDate: (orderModel: IOrder, property: "confirmed_date" | "estimated_shipping_at" | "created_at" | "submit_date") => string,
};

export const PackingListDetailBillToShipToRow = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const uiContext = useContext(UiContext);

    const vendorModel: IVendorModel = _.get(props.packingList, "Vendor", {} as IVendorModel);

    const themeTypeDetail = UIService.getThemeType(supplierModel, userModel);

    const tableTheme = themeTypeDetail.themeType === "DARK"? "table-dark" : "";

    const shipmentGroupShipTo: IAddress = _.get(props.firstOrder, "Ship_To", props.packingList.Vendor?.Ship_To || ({} as IAddress));
    const shipmentGroupBillTo: IAddress = _.get(props.firstOrder, "Bill_To", props.packingList.Vendor?.Bill_To || ({} as IAddress));

    const orderDate = props.getOrderDate();
    const estShipDate = props.orders.length > 2 ? "Mixed" : props.getDate(props.firstOrder, "estimated_shipping_at");
    const cancelDate = props.orders.length > 2 ? "Mixed" : moment(props.firstOrder.cancel_date).format("MM/DD/YYYY");
    const shippingDate = props.orders.length > 2 ? "Mixed" : moment(props.firstOrder.ship_date).format("MM/DD/YYYY");
    const doNotShipBeforeDate = props.orders.length > 2 ? "Mixed" : moment(props.firstOrder.do_not_ship_before_date).format("MM/DD/YYYY");

    const { shipping_instructions, notes, poNumsArr, orderNumsArr, orderDescription } = props.getCompiledData();

    const orderNums = orderNumsArr.join(", ");
    const poNums = poNumsArr.join(",");

    let hasBillToName = true;
    let hasShipToName = true;

    if (!shipmentGroupBillTo?.name?.length || !shipmentGroupBillTo?.company_name?.length) {
        let billToNameSame = false;
        let billToCompanyNameSame = false;

        if (shipmentGroupBillTo?.name === vendorModel?.name) {
            billToNameSame = true;
        }

        if (shipmentGroupBillTo?.company_name === vendorModel?.name) {
            billToCompanyNameSame = true;
        }

        if (!billToNameSame && !billToCompanyNameSame) {
            hasBillToName = false;
        }
    }

    if (!shipmentGroupShipTo?.name?.length || !shipmentGroupShipTo?.company_name?.length) {
        let shipToNameSame = false;
        let shipToCompanyNameSame = false;

        if (shipmentGroupShipTo?.name === vendorModel?.name) {
            shipToNameSame = true;
        }

        if (shipmentGroupShipTo?.company_name === vendorModel?.name) {
            shipToCompanyNameSame = true;
        }

        if (!shipToNameSame && !shipToCompanyNameSame) {
            hasShipToName = false;
        }

        if (props.firstOrder.client_id) {
            hasShipToName = true;
        }
    }

    const getShowBillTo = () => {
        if (props.view.showBillTo) {
            if (props.pageSize === "STANDARD") {
                return true;
            }
        }

        return false;
    };

    return <div className={"PackingListDetailBillToShipToRow"}>
        <div className={"row bill-to-ship-to-row"}>
            {getShowBillTo() ? (
                <div
                    className={
                        (props.pageSize === "STANDARD" ? "w-20r" : "") +
                        " col-auto " +
                        (supplierModel.guid === SupplierGuidEnum.VERMONT ? "d-none" : "")
                    }>
                    <div className={"black-box p-2 h-100"}>
                        <OwTitle leftIconName={"fal fa-building"} className={"underline"} title={"bill_to"} tag={"h5"} />
                        {!hasBillToName ? (
                            <OwTitle title={props.firstOrder.Vendor?.name || ""} tag={"h5"} disableTranslation={true} />
                        ) : null}
                        <AddressDisplay
                            address={shipmentGroupBillTo}
                            showCompanyName={true}
                            showName={true}
                            showPhone={props.view.showBillToPhone}
                            hideMobile={true}
                            hideFax={true}
                            hideEmail={true}
                            nameTag={"h5"}
                        />
                    </div>
                </div>
            ) : null}

            <div
                className={
                    (props.pageSize === "STANDARD" ? "w-20r" : "") +
                    " col-auto " +
                    (supplierModel.guid === SupplierGuidEnum.VERMONT ? "" : "border-left-0")
                }>
                <div className={"black-box p-2 h-100 "}>
                    {props.firstOrder.is_local_pickup ? (
                        <OwTitle
                            leftIconName={"fal fa-hand-holding-box"}
                            title={"local_pickup"}
                            tag={"h5"}
                            className={"underline"}
                        />
                    ) : (
                        <OwTitle
                            leftIconName={"fal fa-truck"}
                            title={props.firstOrder.is_local_delivery ? "deliver_to" : "ship_to"}
                            tag={"h5"}
                            className={"underline"}
                        />
                    )}
                    {!hasShipToName ? <OwTitle title={props.firstOrder.Vendor?.name || ""} tag={"h5"} disableTranslation={true} /> : null}
                    <AddressDisplay
                        address={shipmentGroupShipTo}
                        showCompanyName={!props.firstOrder.client_id}
                        showName={true}
                        showPhone={props.view.showShipToPhone}
                        hideEmail={true}
                        hideFax={true}
                        hideMobile={true}
                        nameTag={"h5"}
                    />
                </div>
            </div>

            {props.pageSize === "MINIMAL" ? (
                <div className={"col-auto"}>
                    <table className={"table table-sm table-bordered w-100 " + tableTheme}>
                        <tbody>
                        <tr>
                            <th>
                                <strong>
                                    <OwLabel title={"order_date"} className={"mb-0"} />
                                </strong>
                            </th>
                            <td>{orderDate}</td>
                        </tr>
                        {supplierModel?.shipping_lead_time ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"est_ship_date"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>{estShipDate}</td>
                            </tr>
                        ) : null}
                        {supplierModel?.has_order_cancel_date ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"cancel_date"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>{props.firstOrder.cancel_date ? cancelDate : null}</td>
                            </tr>
                        ) : null}
                        {!supplierModel?.has_est_ship_date ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"ship_date"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>{props.firstOrder.ship_date ? shippingDate : null}</td>
                            </tr>
                        ) : null}
                        {supplierModel?.has_do_not_ship_before_date ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"do_not_ship_before_date"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>{props.firstOrder.do_not_ship_before_date ? doNotShipBeforeDate : null}</td>
                            </tr>
                        ) : null}
                        {props.totalOrders === 1 ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"order_no"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>{orderNums}</td>
                            </tr>
                        ) : null}
                        {supplierModel?.has_terms_on_packing_list ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"terms"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>
                                    <OwLabel
                                        title={props.firstOrder.Vendor?.Payment_Type?.name.toLowerCase()}
                                        noBottomMargin={true}
                                    />
                                </td>
                            </tr>
                        ) : null}
                        <tr>
                            <th>
                                <strong>
                                    <OwLabel title={"po_no"} className={"mb-0"} />
                                </strong>
                            </th>
                            <td>{poNums}</td>
                        </tr>
                        <tr>
                            <th>
                                <strong>
                                    <OwLabel title={"notes"} className={"mb-0"} />
                                </strong>
                            </th>
                            <td>{notes}</td>
                        </tr>
                        {props.firstOrder.shipping_instructions ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"shipping_instructions"} className={"mb-0"} />
                                    </strong>
                                </th>
                                <td>{props.firstOrder.shipping_instructions}</td>
                            </tr>
                        ) : null}
                        {props.view.showOrderDescription ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"description"} />
                                    </strong>
                                </th>
                                <td>{orderDescription}</td>
                            </tr>
                        ) : null}
                        {props.view.showOrderUser ? (
                            <tr>
                                <th>
                                    <strong>
                                        <OwLabel title={"user"} />
                                    </strong>
                                </th>
                                <td>{props.firstOrder.User?.name}</td>
                            </tr>
                        ) : null}
                        </tbody>
                    </table>
                </div>
            ) : null}
        </div>
    </div>;
};
